import { icons } from "assets"
import Back from "Components/main_components/registeration/Back"
import Button from "Components/shared/button"
import FormControl from "Components/shared/control"
import { InputWithAdornment } from "Components/shared/inputs"
import Select from "Components/shared/select"
import Switch from "Components/shared/switch"
import Text from "Components/shared/text"
import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { postBeneficiary } from "services/transferService"


import styles from '../transfer_components.module.css';

const BeneficiaryDetails = (props) => {
    const {values, errors, touched, handleUpdate} = props;
   const [isLoading, setIsLoading] = useState(false);
   const navigate = useNavigate();
    const submitHandler = async () => {
        setIsLoading(true);
        const {data, message, status} = await postBeneficiary({ 
            "accountNumber": values.account, 
            "accountName": values.name,
            "bank": values.bank,
            "iban": values.iban, 
            "swift": values.swift, 
            "country": values.country,
            
        });
        if(status === 201){
            navigate("/transfer/view-beneficiary");
        }
        setIsLoading(false);

    }

    
    return (
        <div className={styles.SelectBeneficiary}>
           
            <div className={styles.Form}>
            <FormControl label="Account Currency type" name="country"  >
                    <Select 
                    value={values.country}
                    error={errors.country }
                    placeholder="Select currency"
                    options={[{value:"Nigeria", text:"Naira"},
                    {value:"USA",text:"Dollar" },
                     {value:"Europe", text:"Euro"}]}
                     optionsText={item => item.text}
                     optionsValue={item => item.value}
                     name="country"
                     {...handleUpdate()}
                      fullWidth />
                </FormControl>
                <FormControl label="Beneficiary account number" name="account" >
                    <InputWithAdornment
                    value={values.account}
                    error={errors.account && touched.account && errors.account}
                    name="account"
                    {...handleUpdate()}
                      fullWidth />
                </FormControl>
                <FormControl label="Enter Bank Name" name="bank" >
                <InputWithAdornment
                    value={values.bank}
                    error={errors.bank && touched.bank && errors.bank}
                    name="bank"
                    {...handleUpdate()}
                      fullWidth />
                </FormControl>
                <FormControl label="Beneficiary Name" name="name" >
                    <InputWithAdornment fullWidth
                    name="name"
                    error={errors.name && touched.name && errors.name}
                    {...handleUpdate()}
                     value={values.name} />
                </FormControl>
                <FormControl label="SWIFT" name="swift" >
                <InputWithAdornment fullWidth
                error={errors.swift && touched.swift && errors.swift}
                {...handleUpdate()}
                 value={values.swift}
                />
                
                </FormControl>
                <FormControl label="IBAN"  name="iban">
                <InputWithAdornment
                error={errors.iban && touched.iban && errors.iban}
                {...handleUpdate()}
                 value={values.iban}
                 fullWidth />
                
                </FormControl>
                
                
                <FormControl style={{marginTop:"12px"}}>
                    <Button
                    disabled={!!Object.keys(errors).length}
                    loading={isLoading}
                    type="submit"
                    onClick={submitHandler}
                    fullWidth> Add Beneficiary</Button>
                </FormControl>
                
            </div>
        </div>
    )
}

export default BeneficiaryDetails;